module.exports = __webpack_public_path__ + "static/media/scr_landscape.0730fcd2.png";